/**
 * @file 个人信息弹窗
 * @description 只读展示账号、校区名称、点数。
 *
 * @whenToUse 顶栏用户菜单「个人信息」。
 * @whenNotToUse 可编辑资料表单（另做编辑弹窗）。
 */

import { Button } from '@/components/ui/button.tsx'
import { Descriptions } from '@/components/ui/descriptions.tsx'
import { Dialog } from '@/components/ui/dialog.tsx'

export type AdminProfileDialogProps = {
  /** 是否打开 */
  open: boolean
  /** 打开状态变化 */
  onOpenChange: (open: boolean) => void
  /** 账号 */
  username: string
  /** 校区名称 */
  campusName: string
  /** 点数 */
  points: number
}

/**
 * 个人信息展示弹窗。
 */
export function AdminProfileDialog({
  open,
  onOpenChange,
  username,
  campusName,
  points,
}: AdminProfileDialogProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
      title="个人信息"
      footer={
        <Button variant="secondary" onClick={() => onOpenChange(false)}>
          关闭
        </Button>
      }
    >
      <Descriptions
        columns={1}
        items={[
          { key: 'username', label: '账号', children: username },
          { key: 'campus', label: '校区名称', children: campusName },
          { key: 'points', label: '点数', children: points },
        ]}
      />
    </Dialog>
  )
}
